export enum FulfillmentType {
  DineIn = 'DineIn',
  TakeOut = 'TakeOut',
  ProducerDelivery = 'ProducerDelivery',
  YoutopiaDelivery = 'YoutopiaDelivery',
  PrivateEventsCatering = 'PrivateEventsCatering',
  InHomePrivateChef = 'InHomePrivateChef'
}

export const FulfillmentTypeLabels: Record<FulfillmentType, string> = {
  [FulfillmentType.DineIn]: 'Dine In',
  [FulfillmentType.TakeOut]: 'Take Out',
  [FulfillmentType.ProducerDelivery]: 'Producer Delivery',
  [FulfillmentType.YoutopiaDelivery]: 'Youtopia Delivery',
  [FulfillmentType.PrivateEventsCatering]: 'Private Events Catering',
  [FulfillmentType.InHomePrivateChef]: 'In-Home Private Chef'
};

export interface FulfillmentWindowSettingsV1 {
  fulfillmentType: FulfillmentType;
  offsetMinutes: number;
  durationMinutes: number;
}

export interface UpdateFulfillmentWindowSettingsRequestV1 {
  offsetMinutes: number;
  durationMinutes: number;
}
